import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col ant-col-xs-24 ant-col-md-24",
  align: "center"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-md-8 retorno-requisicao-imagem" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-md-16" }
const _hoisted_10 = { class: "retorno-requisicao" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "retorno-requisicao-botoes" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Ok", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.dados.computedVisivel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_modal, {
          keyboard: false,
          centered: "",
          width: 700,
          visible: _ctx.dados.computedVisivel,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dados.computedVisivel) = $event)),
          closable: false,
          maskClosable: false,
          title: '',
          footer: false
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  width: "250",
                  src: _ctx.dados.computedVisivel?'/static/img/ilustracoes/aguarde.png':'',
                  alt: "Aguarde por favor"
                }, null, 8, _hoisted_4),
                _hoisted_5,
                _createVNode(_component_barra_progresso, {
                  visivel: _ctx.props.apresentarBarraProgresso,
                  "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.props.apresentarBarraProgresso) = $event)),
                  frase: _ctx.props.fraseBarraProgresso?_ctx.props.fraseBarraProgresso:undefined
                }, null, 8, ["visivel", "frase"])
              ])
            ], 512), [
              [_vShow, _ctx.props.apresentarBarraProgresso]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  width: "250",
                  src: _ctx.dados.arquivoImagem,
                  alt: "Imagem retorno Requisição"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.dados.computedTitulo)
                    ? (_openBlock(), _createElementBlock("h3", {
                        key: 0,
                        innerHTML: _ctx.dados.computedTitulo
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "retorno-requisicao-texto",
                    innerHTML: _ctx.retornoRequisicao.mensagem
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary retorno-requisicao-botao",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args)))
                    }, _hoisted_15)
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.props.apresentarBarraProgresso]
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}